module.exports = __webpack_public_path__ + "img/full-character.499b744b.png";